module.exports = __webpack_public_path__ + "img/vincere-icon.a4495f46.png";